import {useWebVitals} from '@github-ui/use-web-vitals'
import {sendCustomMetric} from '@github-ui/stats'

export type LandingPageWebVitalsTrackerProps = {
  /** Page identifier derived from pathname (e.g., 'features.spark', 'features.copilot') */
  page: string
}

/**
 * Tracks Web Vitals (HPC, CLS, LCP, INP) for /features/:slug landing pages.
 *
 * This component listens to Web Vitals events and sends custom metrics to Datadog
 * with page-level tags. The page identifier follows double prefix format: /features/spark → features.spark
 *
 * @example
 * ```tsx
 * <LandingPageWebVitalsTracker page="features.spark" />
 * ```
 */
export function LandingPageWebVitalsTracker({page}: LandingPageWebVitalsTrackerProps) {
  const tags: Record<string, string> = {page}

  useWebVitals('hpc', event => {
    if (!event.detail.hpc) return
    sendCustomMetric({
      name: 'LANDING_PAGES_VITALS_HPC',
      value: event.detail.hpc,
      tags,
    })
  })

  useWebVitals('cls', event => {
    if (!event.detail.cls) return
    sendCustomMetric({
      name: 'LANDING_PAGES_VITALS_CLS',
      value: event.detail.cls,
      tags,
    })
  })

  useWebVitals('lcp', event => {
    if (!event.detail.lcp) return
    sendCustomMetric({
      name: 'LANDING_PAGES_VITALS_LCP',
      value: event.detail.lcp,
      tags,
    })
  })

  useWebVitals('inp', event => {
    if (!event.detail.inp) return
    sendCustomMetric({
      name: 'LANDING_PAGES_VITALS_INP',
      value: event.detail.inp,
      tags,
    })
  })

  return null
}
